import { render } from "./SearchResults.vue?vue&type=template&id=5e186850"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"
script.render = render

export default script